export const objectToFormData = <T extends Object>(data: T) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value) && value.every((val) => val instanceof Blob)) {
            return value.forEach((file) => {
                formData.append(`${key}[]`, file);
            });
        }
        if (value !== undefined && value !== null) {
            const formattedValue = value instanceof Blob ? value : String(value);
            return formData.append(key, formattedValue);
        }
    });

    return formData;
};
